var map = {
	"./bg.png": "dc97",
	"./bg1.png": "756d",
	"./kovy.png": "2609",
	"./kovy@2x.png": "af54",
	"./kovy@3x.png": "e4b5",
	"./papir.png": "8123",
	"./papir@2x.png": "1ddc",
	"./papir@3x.png": "9b55",
	"./pet.png": "a309",
	"./pet@2x.png": "8be5",
	"./pet@3x.png": "da5c",
	"./sklo.png": "096e",
	"./sklo@2x.png": "8db5",
	"./sklo@3x.png": "ff90",
	"./smesny.png": "7343",
	"./smesny@2x.png": "5ac2",
	"./smesny@3x.png": "f070",
	"./tetra.png": "1701",
	"./tetra@2x.png": "7007",
	"./tetra@3x.png": "3312"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";